import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=4ac1d99e&scoped=true&"
import script from "./UserSearch.vue?vue&type=script&lang=ts&"
export * from "./UserSearch.vue?vue&type=script&lang=ts&"
import style0 from "./UserSearch.vue?vue&type=style&index=0&id=4ac1d99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1d99e",
  null
  
)

export default component.exports